import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import 'babel-polyfill'
import './plugins/element.js'
import './assets/css/base/base.scss'
import './assets/css/ele/theme/index.css'
import axios from 'axios'
import VueCookies from 'vue-cookies'
import './router.service'
import './assets/css/iconfont/iconfont.css'
import Router from 'vue-router'
import VuePhotoZoomPro from "vue-photo-zoom-pro";
import 'element-ui/lib/theme-chalk/index.css';
import 'vue-area-linkage/dist/index.css'
import animate from 'animate.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import BasicTable from '@/components/table/table.components'
import moment from 'moment'
import { handleThumbnailUrl } from './utils';
import { Icon } from 'ant-design-vue';

Vue.component('Icon', Icon);
Vue.component('BasicTable', BasicTable)
Vue.use(VueAwesomeSwiper)
Vue.use(animate)
Vue.use(VuePhotoZoomPro);
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.filter('dateFormat', function (dateStr, formatStr = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dateStr).format(formatStr)
})

Vue.filter('thumbnailUrl', handleThumbnailUrl);

Vue.prototype.$ajax = axios
Vue.config.productionTip = false
Vue.use(VueCookies)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
